import { c as _c } from "react/compiler-runtime";
import { signOut } from '../actions';
export function LogoutForm() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <form action={signOut}><button>Log out</button></form>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}